import React from 'react';
import { connect } from 'react-redux';
import './styles.scss';
import { IAppState } from 'src/store';
import { Text, View, Image, IconClickable, Checkbox } from '../common';
import ActionDropdown from './ActionDropdown';
import { getFileIcon } from 'src/utils/fileUtils';
import { DepositionStatus, FileData, FileType } from 'src/dataFactory/depositionFactory';
import { MODAL_TYPES } from 'src/appConfig/modal';
import { modalActions } from 'src/redux/modalRedux';
import { DropdownItem } from '../common/CustomDropdown';
import { FilePreDownloadPayload } from 'src/redux/fileRedux/types';

const DepositionFileItem: React.FC<Props> = ({
  isGrid = true,
  fileType = 'exhibit',
  status = 'pending',
  data,
  isMulti,
  onSelect,
  onDelete,
  onRename,
  onDownload,
  showModal,
  closeModal,
}) => {
  const fileIcon = getFileIcon(data.extension.toLowerCase());
  const handleDownloadFile = () => {
    if (onDownload != null) {
      onDownload({ downloadUri: data.downloadUri, fileName: `${data.name}.${data.extension}` });
    }
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onSelect != null) {
      onSelect(data);
    }
  };

  const handleDeleteFile = () => {
    onDelete != null && onDelete([data]);
  };

  const handleOpenRenameModal = () => {
    showModal({
      type: MODAL_TYPES.RENAME_MODAL,
      data: {
        title: 'Rename File',
        defaultValue: data.name,
        onOk: (value: string) => {
          onRename != null && onRename(data, value);
        },
        onCancel: closeModal,
      },
    });
  };

  // Variables
  let actionOptions: DropdownItem[] = [];
  actionOptions.push({ label: 'RENAME', icon: 'ic_edit', onClick: handleOpenRenameModal });
  actionOptions.push({ label: 'DELETE', icon: 'ic_trash', onClick: handleDeleteFile });

  return (
    <View className={'cmp-deposition-file'}>
      <div
        className={`box cmp-deposition-file__item ${isGrid ? 'cmp-deposition-file__item--grid' : ''} ${
          data.isSelected && isMulti ? 'cmp-deposition-file__item--multi-checked' : ''
        }`}>
        <View isRow={!isGrid} justify="space-between">
          <View isRow justify={isGrid ? 'space-between' : undefined} align={isGrid ? undefined : 'center'}>
            <Checkbox.Item onChange={handleCheckboxChange} checked={data.isSelected} key={`check-box-${data.id}`} />
            {isGrid ? (
              <ActionDropdown options={actionOptions} />
            ) : (
              <Image
                className={'cmp-deposition-file__item-image cmp-deposition-file__item-image--column'}
                src={fileIcon}
              />
            )}
            {!isGrid && (
              <Text
                className={
                  'cmp-deposition-file__item-name cmp-deposition-file__item-name-full fw-bold'
                }>{`${data.name}.${data.extension}`}</Text>
            )}
          </View>
          {isGrid && (
            <View className="mb-40 mt-12" justify="space-around" align="center">
              <Image className={'cmp-deposition-file__item-image'} src={fileIcon} />
            </View>
          )}
          <View
            isRow
            justify={isGrid ? 'space-between' : undefined}
            align={'center'}
            className={`ctn-file-item-${isGrid ? 'grid' : 'row'}`}>
            {isGrid
              ? [
                  <Text
                    title={`${data.name}.${data.extension}`}
                    key={`file-name-${data.id}`}
                    className={'cmp-deposition-file__item-name fw-bold'}>
                    {`${data.name}.${data.extension}`}
                  </Text>,
                  <IconClickable
                    key={`file-download-${data.id}`}
                    name="ic_download"
                    className={'cmp-deposition-file__item-icon cmp-deposition-file__item-icon-download'}
                    onClick={() => {
                      handleDownloadFile();
                    }}
                  />,
                ]
              : [
                  <IconClickable
                    key={`file-download-${data.id}`}
                    name="ic_download"
                    className={'cmp-deposition-file__item-icon mr-12'}
                    onClick={() => {
                      handleDownloadFile();
                    }}
                  />,
                  <ActionDropdown key={`file-more-${data.id}`} options={actionOptions} />,
                ]}
          </View>
        </View>
      </div>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    index?: number | undefined;
    fileType?: FileType | undefined;
    isGrid?: boolean | undefined;
    data: FileData;
    isMulti: boolean;
    status?: DepositionStatus;
    onSelect?: (fileData: FileData) => void;
    onDelete?: (files: FileData[]) => void;
    onRename?: (fileData: FileData, updateName: string) => void;
    onDownload?: (file: FilePreDownloadPayload) => void;
  };
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {
  showModal: modalActions.showModal,
  closeModal: modalActions.closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DepositionFileItem);
